export const aeCoinHints = {
  aeCoin: 'æternity native coin.',
  tokenSymbol: 'Reserved coin name.',
  price: 'Price of the coin in AE and USD.',
  totalSupply: 'Amount of coins in circulation.',
  circulating: 'Amount of distributed coins minus the burned amount.',
  decimals: 'The decimal granularity of the coin.',
  marketName: 'Name of the exchange market name.',
  pair: 'Trading token pair at given market.',
  marketPrice: 'Price of the token in USD at given exchange.',
  volume: '24h transaction volume in USD at given exchange.',
}
